import { Component, OnInit, ViewChild,ElementRef } from '@angular/core';
import { CorporateService } from '../../_service/corporate.service';
import { LeadsService } from '../../_service/leads.service';
import { SharedService } from '../../_service/shared.service';
import { UserService } from '../../_service/user.service';
import { HotTableRegisterer } from '@handsontable/angular';
import {PageEvent, MatPaginator} from '@angular/material/paginator';
declare var $: any;
@Component({
  selector: 'app-corporate-lead-sheetview',
  templateUrl: './corporate-lead-sheetview.component.html',
  styleUrls: ['./corporate-lead-sheetview.component.css']
})
export class CorporateLeadSheetviewComponent implements OnInit {
  @ViewChild('dateRangeStart', {static: false}) dateRangeStart: ElementRef;
    @ViewChild('dateRangeEnd', {static: false}) dateRangeEnd: ElementRef;

  @ViewChild('paginatorBottom', {static: false}) paginatorBottom: MatPaginator;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('csvUploadFb', {static: false}) csvUploadFb: ElementRef;
  private hotRegisterer = new HotTableRegisterer();settings = {colHeaders: true };hideColumn:any;loaded:boolean=false;perpage:number=25;length:number=0;pageEvent: PageEvent;loading:boolean=true;id = 'hotInstance';userId:string;status:number;
  pageSizeOptions = [10,25,50,100];pageIndex:number=0;myrole:string;corporate_lead_status=[];corporate_leads=[];search:string;submitted = false;sheetCircle=[];bds=[];incorporate_licence=[];cover_type=[];policy_type=[];sum_insured=[];corporate_lead_status_list=[];circles=[];circle='';bds_list=[];bd:string;s3url:string='';start_date:string='';end_date:string='';nimbus_end_to_call_btn_disable=false;end_to_call_btn_disable=false;nimbus_click_to_call_loading:boolean=false;
  constructor(private sharedapi:SharedService, private userapi:UserService, private corporateapi:CorporateService,private leadapi:LeadsService) { }

  ngOnInit(): void {
    this.sharedapi.getRole().subscribe((item:string) => {this.myrole=item;});
    this.s3url = localStorage.getItem('s3url');
    this.myrole = localStorage.getItem('role');
    this.loadCommonData();
    this.getCorporateStatusLists();
    this.getbds();
    this.getcircle();
  }

  ngAfterViewInit() {
    this.getCorporateLeads(0,25);
  }

  dateRangeChange(date1,date2)
  {
      if(date2.value)
      {
          this.start_date = date1.value;
          this.end_date = date2.value;
          this.getCorporateLeads(0,this.perpage);
      }
  }
  clearDate()
  {
      this.dateRangeStart.nativeElement.value = "";
      this.dateRangeEnd.nativeElement.value = "";
      this.start_date = '';
      this.end_date = '';
      this.getCorporateLeads(0,this.perpage);
  }

  hideModalFb()
  {
      $('#myModalfb').modal('hide');
  }

  showModalFb()
  {
      $('#myModalfb').modal();
  }

  async selectFileFb(event)
  {
      this.submitted = true;
      let file = event.target.files.item(0);
      const formData = new FormData();
      formData.append('file', file);
      this.leadapi.uploadcsvCorporateFb(formData)
      .subscribe((data:any) => {
          this.submitted = false;
          this.csvUploadFb.nativeElement.value = "";
          if(data.status)
          {
              this.hideModalFb();
              this.sharedapi.presentToast(data.msg);
          }
          else
          {
              this.sharedapi.presentToast(data.msg);
          }
        }, error =>
          {
              this.sharedapi.checkError(error);
          });
  }

  async getbds(status=1)
  {
    this.leadapi.getbdsofCorporate(status).subscribe((data:any) => {
        if(data.status)
        {
            this.bds_list = data.data;
        }else{
            this.bds_list = [];
        }
    }, error => {
        this.sharedapi.checkError(error);
    });
  }

  async getcircle()
  {
      await this.leadapi.getcircles().subscribe((data:any) => {
          if(data.status)
          {
              this.circles = data.data;
          }else{
              this.circles = [];
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

  async getCorporateStatusLists()
  {
    await this.corporateapi.getCorporateStatusLists().subscribe((data:any) => {
      if(data.status)
      {
        this.corporate_lead_status_list = data.data;
      }
      else
      {
        this.corporate_lead_status_list = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }
  
  async loadCommonData()
  {
    await this.corporateapi.getCommonData().subscribe((data:any) => {
        if(data.status)
        {
            this.bds = data.bd;
            this.sheetCircle = data.circle; 
            this.corporate_lead_status = data.lead_status;
            this.incorporate_licence = data.incorporate_licence;
            this.cover_type = data.cover_type;
            this.policy_type = data.policy_type;
            this.sum_insured = data.sum_insured;
        }else{
          this.bds = [];
          this.sheetCircle = []; 
          this.corporate_lead_status = [];
          this.incorporate_licence = [];
          this.cover_type = [];
          this.policy_type = [];
          this.sum_insured = [];
        }
    }, error => {
        this.sharedapi.checkError(error);
    });
  }

  async getCorporateLeads(pageIndex,perpage)
  {
    this.paginator.pageIndex = pageIndex;
    this.paginatorBottom.pageIndex = pageIndex;
    this.pageIndex = pageIndex;
    this.loading = true;this.loaded = false;
    let qString = 'search='+this.search+'&status='+this.status+'&circle='+this.circle+'&bd='+this.bd+'&date_range='+this.start_date+'-'+this.end_date;
    this.corporateapi.getCorporateLeadsForsheetview(pageIndex,perpage,qString).subscribe((data:any) => {
        this.length = parseInt(data.totaldata);
        this.loading = false;
        this.loaded = true;
        if(data.status)
        {
            this.corporate_leads = data.data;
        }else{
            this.corporate_leads = [];
        }
    }, error => {
        this.sharedapi.checkError(error);
    });
  }

  public getServerData(event:PageEvent):any
  {
      this.perpage = event.pageSize;
      this.pageIndex = event.pageIndex;
      this.getCorporateLeads(event.pageIndex,event.pageSize);
  }

  onBeforeChange = (hotInstance, changes) =>
  {
      let data= this.hotRegisterer.getInstance(this.id).getSourceData();
      let saveData = {id:data[hotInstance[0][0]].id,field_name:hotInstance[0][1],old_value:hotInstance[0][2],new_value:hotInstance[0][3]};
      if(saveData.new_value) {
        this.saveOnChange(saveData);
      }else{
        this.sharedapi.presentToast('This field will not be blank');
      }
      
  }

  async saveOnChange(saveData)
  {
      this.submitted = true;
      await this.corporateapi.UpdateCorporateLeadsFromSheetview(saveData).subscribe((data:any) =>
      {
          this.submitted = false;
          this.sharedapi.presentToast(data.msg);
      }, error => {
              this.sharedapi.checkError(error);
      });

  }

  afterOnCellMouseDownCallBack = (event, coords, TD) =>
  {
      if(event.target.className == 'nimbus_click_to_call')
      {
          let leadId = event.target.attributes.id.nodeValue;
          this.corporate_lead_nimbus_click_to_call_function(leadId);
      }
  }

  corporate_lead_nimbus_click_to_call_function(lead_id)
  {
    console.log("This is for testing. Lead ID => "+lead_id);
    this.nimbus_click_to_call_loading = true;
    let nimbus_lead_id_arr = {'lead_id': lead_id};
    $("#nimbus_click_to_call_progress").modal("show");
    this.corporateapi.nimbusClickTOCallForCorporateLeads(nimbus_lead_id_arr).subscribe((data:any) => {
        this.nimbus_click_to_call_loading = false;
        if(data.status==false){
            $("#nimbus_click_to_call_progress").modal("hide");
            this.sharedapi.presentToast(data.msg);
        }
    }, error => {
        this.sharedapi.checkError(error);
    });
  }

  endNimbusClicktoCall()
  {
      this.end_to_call_btn_disable = true;
      $('#nimbus_click_to_call_progress').modal('hide');
      this.end_to_call_btn_disable = false;
  }

}
